<template>
  <div class="fail">
    <div>
      <div>
        <div class="errorLogo">
          <img src="/assets/invalid_session_token_error.png" />
        </div>
        <div class="bigText blue">{{ $t("expired") }}</div>
      </div>
      <div class="text blue incompletedReturn">
        {{ $t("expired_sub_header") }}
      </div>
      <div class="text lineContainer">
        <div class="line"></div>
        <div>{{ $t("expired_or") }}</div>
        <div class="line"></div>
      </div>
      <div class="text blue incompletedHistory">
        {{ $t("expired_details") }}
      </div>
    </div>
    <div class="warn blue">
      <div class="">
        <span class="blue">{{ $t("gentle") }}</span
        ><span class="line"></span><span v-html="reminderMessage"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    reminderMessage() {
      const link =
        '<span class="white">https://verify.pgslotxaskmebet.com</span>';
      return this.$t("reminder", { link });
    },
  },
};
</script>
